import { render, staticRenderFns } from "./ExpertiseTabItems.vue?vue&type=template&id=d8b361ec&scoped=true"
import script from "./ExpertiseTabItems.vue?vue&type=script&lang=js"
export * from "./ExpertiseTabItems.vue?vue&type=script&lang=js"
import style0 from "./ExpertiseTabItems.vue?vue&type=style&index=0&id=d8b361ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b361ec",
  null
  
)

export default component.exports